import React from 'react'
import { useTabsNavigation, CrudTabs, CrudRoute } from 'elentari'
import CentroCustoForm from './CentroCustoForm'
import GestoresCentroCusto from './Gestores/GestoresCentroCusto'
import GestoresCentroCustoForm from './Gestores/GestoresCentroCustoForm'
import AnalistaCentroCustos from './Analistas/AnalistaCentroCustos'
import AnalistaCentroCustoForm from './Analistas/AnalistaCentroCustoForm'

function CentroCustoTabs() {
  const tabsNavigation = useTabsNavigation({
    mainPath: 'centrosCusto',
    tabs: [
      { value: '', label: 'Centro de Custo' },
      { value: 'gestores', label: 'Gestores' },
      { value: 'analistasPreferenciais', label: 'Analistas Preferenciais' }
    ]
  })
  return (
    <CrudTabs {...tabsNavigation}>
      <div>
        <CrudRoute render={props => <CentroCustoForm {...props} />} />
        <CrudRoute
          name="gestores"
          render={props => (
            <GestoresCentroCusto
              onClickNew={tabsNavigation.toNewChild}
              onClickEdit={tabsNavigation.toEditChild}
              {...props}
            />
          )}
        />
        <CrudRoute
          name="gestores"
          isForm
          render={props => <GestoresCentroCustoForm {...props} />}
        />
        <CrudRoute
          name="analistasPreferenciais"
          render={props => (
            <AnalistaCentroCustos
              onClickNew={tabsNavigation.toNewChild}
              onClickEdit={tabsNavigation.toEditChild}
              {...props}
            />
          )}
        />
        <CrudRoute
          name="analistasPreferenciais"
          isForm
          render={props => <AnalistaCentroCustoForm {...props} />}
        />
      </div>
    </CrudTabs>
  )
}

export default CentroCustoTabs
